<script>
import Title from "@/components/admin/common/TitleArea.vue"

const defaultForm = () => ({
  id: null,
  type: 'HB',
  name: '',
  min_value: 0,
  max_value: 0,
  base_value: 0,
  next_sequence_id: null,
  is_active: true
})

export default {
  name: "Admin-console-management",
  meta: {
    title: "어드민-화물번호 대역폭관리"
  },
  components: {
    Title
  },
  computed: {
    sortedList () {
      return this.configList.reduce((acc, item) => {
        const key = item.type || 'UNKNOWN'
        if (!acc[key]) acc[key] = []
        acc[key].push(item)
        return acc
      }, {})
    },
    nextSequenceOptions () {
      if (!this.form.name) return []

      return this.configList
        .filter(item => item.name === this.form.name && item.id !== this.form.id && item.is_active === 1)
        .map(item => ({
          label: `${item.id} | ${item.name} | ${this.formatNumber(item.min_value)} ~ ${this.formatNumber(item.max_value)}`,
          value: item.id
        }))
    }
  },
  data() {
    return {
      description: {
        title: '화물번호 대역폭관리'
      },
      form: defaultForm(),
      message: '',
      configList: [],
      columns: [
        { name: 'id', label: 'ID', align: 'center', field: 'id' },
        { name: 'name', label: '시퀀스 이름', align: 'center', field: 'name' },
        { name: 'min_value', label: '처음 채번번호', align: 'center', field: 'min_value', format: val => this.formatNumber(val) },
        { name: 'max_value', label: '마지막 채번번호', align: 'center', field: 'max_value', format: val => this.formatNumber(val) },
        { name: 'base_value', label: '기본 시퀀스 폼', align: 'center', field: 'base_value', format: val => this.formatNumber(val) },
        { name: 'current_hbl_no', label: '현재 채번번호', align: 'center', field: 'current_hbl_no', format: val => this.formatNumber(val) },
        { name: 'next_sequence_id', label: '다음 대역 ID', align: 'center', field: 'next_sequence_id', format: val => val == null ? '-' : val },
        { name: 'is_active', label: '활성', align: 'center', field: 'is_active' },
        { name: 'is_current', label: '현재 대역', align: 'center', field: 'is_current' },
        { name: 'round', label: '참고 회차', align: 'center', field: 'round', format: val => this.formatNumber(val) },
        { name: 'actions', label: '관리', align: 'center', field: 'actions' },
      ]
    }
  },
  methods: {
    formatNumber (val) {
      const num = Number(val)
      return Number.isFinite(num) ? num.toLocaleString() : val
    },
    getTypeLabel (type) {
      const found = this.$store.getters.getSeqTypeList.find(item => item.value === type)
      return found ? found.label : type
    },
    resetForm () {
      this.form = defaultForm()
      this.message = ''
    },
    startEdit (row) {
      this.form = {
        id: row.id,
        type: row.type,
        name: row.name,
        min_value: Number(row.min_value),
        max_value: Number(row.max_value),
        base_value: Number(row.base_value),
        next_sequence_id: row.next_sequence_id == null ? null : Number(row.next_sequence_id),
        is_active: Number(row.is_active) === 1
      }
      this.message = `ID ${row.id} 대역 수정 모드입니다.`
    },
    async saveConfig() {
      if (!this.form.name ||
          this.form.min_value === null ||
          this.form.max_value === null ||
          this.form.base_value === null) {
        this.$log.error("모든 필드를 입력해주세요.")
        this.message = "모든 필드를 입력해주세요."
        return
      }

      if (Number(this.form.max_value) <= Number(this.form.min_value)) {
        this.message = "마지막 채번번호는 처음 채번번호보다 커야 합니다."
        return
      }

      try {
        const payload = {
          id: this.form.id,
          type: this.form.type,
          name: this.form.name,
          min_value: this.form.min_value,
          max_value: this.form.max_value,
          base_value: this.form.base_value,
          next_sequence_id: this.form.next_sequence_id,
          is_active: this.form.is_active ? 1 : 0
        }

        const config = {
          method: "POST",
          url: "/api/seqConfig/save",
          data: payload,
          name: "[ Axios / 화물번호 대역폭 관리 / 저장 ]"
        }

        const response = await this.$http(config)
        this.$log.debug("저장 성공", response.data)
        this.message = this.form.id ? "화물번호 대역폭이 수정되었습니다." : "화물번호 대역폭이 저장되었습니다."
        this.resetForm()
        this.fetchConfigList()
      } catch (error) {
        this.$log.error("저장 실패", error)
        this.message = error?.response?.data?.message || "화물번호 대역폭 저장에 실패했습니다."
      }
    },
    async fetchConfigList() {
      try {
        const config = {
          method: "GET",
          url: "/api/seqConfig/sequence-list",
          name: "[ Axios / 화물번호 대역폭 관리 / 목록 불러오기 ]"
        }

        const response = await this.$http(config)
        this.$log.debug("목록 불러오기 성공", response.data)
        this.configList = response.data.data || []
      } catch (error) {
        this.$log.error("목록 불러오기 실패", error)
        this.message = error?.response?.data?.message || "화물번호 대역폭 목록을 불러오는 데 실패했습니다."
      }
    },
    async setCurrentSequence (row) {
      if (!window.confirm(`ID ${row.id}를 현재 대역으로 설정하시겠습니까?`)) return

      try {
        await this.$http({
          method: 'PATCH',
          url: '/api/seqConfig/current',
          data: {
            name: row.name,
            current_sequence_id: row.id
          },
          name: '[ Axios / 화물번호 대역폭 관리 / 현재 대역 변경 ]'
        })

        this.message = `ID ${row.id}가 현재 대역으로 설정되었습니다.`
        this.fetchConfigList()
      } catch (error) {
        this.$log.error("현재 대역 변경 실패", error)
        this.message = error?.response?.data?.message || "현재 대역 변경에 실패했습니다."
      }
    },
    async deactivateSequence (row) {
      if (!window.confirm(`ID ${row.id} 대역을 비활성화하시겠습니까?`)) return

      try {
        await this.$http({
          method: 'DELETE',
          url: '/api/seqConfig/delete',
          data: { id: row.id },
          name: '[ Axios / 화물번호 대역폭 관리 / 비활성화 ]'
        })

        this.message = `ID ${row.id} 대역이 비활성 처리되었습니다.`
        if (this.form.id === row.id) this.resetForm()
        this.fetchConfigList()
      } catch (error) {
        this.$log.error("비활성화 실패", error)
        this.message = error?.response?.data?.message || "비활성화에 실패했습니다."
      }
    },
    init () {
      this.$getCodeList("SEQTYP")
        .finally(() => {
          this.fetchConfigList()
        })
    }
  },
  mounted() {
    this.init()
  },
}
</script>

<template>
  <q-page class="q-pa-lg">
    <div class="row q-mb-lg">
      <div class="col">
        <Title :desc="description" />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="comp-box mb-4">
          <p>
            화물번호 대역폭 관리는 화물번호의 시작과 끝, 다음 대역 연결, 현재 활성 대역을 함께 관리합니다.<br />
            현재 대역이 소진되면 `next_sequence_id`로 연결된 다음 대역으로 전환됩니다.<br />
            현재 대역은 그룹별로 하나만 존재해야 하며, 시작 상태가 아닌 대역은 자동 전환 대상이 될 수 없습니다.
          </p>

          <div class="q-gutter-md row q-mb-md">
            <q-select
              v-model="form.type"
              :options="$store.getters.getSeqTypeList"
              behavior="menu"
              label="타입"
              emit-value
              map-options
              outlined />
            <q-input
              v-model="form.name"
              label="시퀀스 이름"
              class="col"
              :disable="!!form.id"
              outlined
              placeholder="예: KOREA POST"
              hide-bottom-space
              required />
            <q-input
              v-model.number="form.min_value"
              label="처음 채번번호"
              type="number"
              class="col"
              outlined
              hide-bottom-space
              required />
            <q-input
              v-model.number="form.max_value"
              label="마지막 채번번호"
              type="number"
              class="col"
              outlined
              hide-bottom-space
              required />
            <q-input
              v-model.number="form.base_value"
              label="기본 시퀀스 폼"
              type="number"
              class="col"
              outlined
              hide-bottom-space
              required />
          </div>

          <div class="q-gutter-md row q-mb-md">
            <q-select
              v-model="form.next_sequence_id"
              :options="nextSequenceOptions"
              emit-value
              map-options
              clearable
              label="다음 대역"
              class="col-4"
              outlined />
            <q-toggle
              v-model="form.is_active"
              label="활성 여부"
              left-label
              color="primary" />
            <q-btn
              type="submit"
              :label="form.id ? '수정하기' : '저장하기'"
              color="primary"
              @click="saveConfig"
              unelevated />
            <q-btn
              flat
              color="grey-7"
              label="초기화"
              @click="resetForm" />
          </div>

          <q-separator class="q-mb-md" />

          <div class="q-gutter-md row">
            <div v-if="message" class="mt-4 text-green-600">
              {{ message }}
            </div>
          </div>

          <template v-for="(list, key) in sortedList" :key="key">
            <h5 class="text-h5 q-mt-md q-mb-sm">
              {{ getTypeLabel(key) }}
            </h5>
            <q-table
              :rows="list"
              :columns="columns"
              row-key="id"
              flat
              bordered>
              <template #body-cell-is_active="props">
                <q-td :props="props">
                  <q-badge :color="Number(props.row.is_active) === 1 ? 'positive' : 'grey-6'">
                    {{ Number(props.row.is_active) === 1 ? '활성' : '비활성' }}
                  </q-badge>
                </q-td>
              </template>

              <template #body-cell-is_current="props">
                <q-td :props="props">
                  <q-badge :color="Number(props.row.is_current) === 1 ? 'primary' : 'grey-5'">
                    {{ Number(props.row.is_current) === 1 ? '현재 대역' : '-' }}
                  </q-badge>
                </q-td>
              </template>

              <template #body-cell-actions="props">
                <q-td :props="props">
                  <div class="row q-gutter-sm justify-center">
                    <q-btn
                      size="sm"
                      color="primary"
                      flat
                      label="수정"
                      @click="startEdit(props.row)" />
                    <q-btn
                      size="sm"
                      color="secondary"
                      flat
                      label="현재 대역"
                      @click="setCurrentSequence(props.row)" />
                    <q-btn
                      size="sm"
                      color="negative"
                      flat
                      label="비활성"
                      @click="deactivateSequence(props.row)" />
                  </div>
                </q-td>
              </template>
            </q-table>
          </template>
        </div>
      </div>
    </div>
  </q-page>
</template>

<style scoped>
</style>
